export function neighborCalc(totalPages, currentPage) {
  return totalPages === currentPage || totalPages < 3 ? 0 : 2;
}
